module.exports = __webpack_public_path__ + "media/images/common/regist_btn_l-2873548979b180411ad8ef20b833c1c8.png";